export default {
     /// <summary>
        /// Chờ trong database
        /// </summary>
        None: 0,

        /// <summary>
        /// Đã lấy khỏi database và đang chờ trong memory
        /// </summary>
        DequeuInMemory: 1,

        /// <summary>
        /// Đang xử lý 
        /// </summary>
        CreateDataProcessing: 2,

        /// <summary>
        /// Thành công
        /// </summary>
        Success: 3,

        /// <summary>
        /// Lỗi
        /// </summary>
        Error: 4,

        /// <summary>
        /// Chờ upload file
        /// </summary>
        Wait: 5
  };
  